/* eslint-disable jsdoc/require-jsdoc, jsdoc/require-param, jsdoc/require-returns, jsdoc/require-description-complete-sentence */
// Hardcoded invoice values — replace with real ones from finance.
// See docs/INVOICE_DETAILS_TODO.md for the list of fields awaiting manager input.

export const INVOICE_COMPANY = {
  name: 'Telos Air, Inc.',
  addressLine1: 'TBD — street',
  addressLine2: '',
  cityStateZip: 'TBD — city, ST 00000',
  country: 'USA',
  email: 'billing@telosair.com',
  phone: 'TBD — phone',
  website: 'https://telosair.com',
  taxId: 'TBD — EIN'
};

export const INVOICE_FOOTER_TEXT = 'Paid via PayPal. No amount due.';

// Set to null to hide the tax row entirely.
export const INVOICE_TAX: { label: string; ratePct: number } | null = null;

/**
 * Format invoice number from payment ID and date.
 * Default format: INV-YYYYMM-{paymentId}
 */
export function formatInvoiceNumber(paymentId: number, paymentDate: Date): string {
  const y = paymentDate.getFullYear();
  const m = String(paymentDate.getMonth() + 1).padStart(2, '0');
  return `INV-${y}${m}-${paymentId}`;
}
